import { render } from "./pager.vue?vue&type=template&id=ecc0c0a4"
import script from "./pager.vue?vue&type=script&lang=js"
export * from "./pager.vue?vue&type=script&lang=js"

import "./pager.vue?vue&type=style&index=0&id=ecc0c0a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__